var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"social-signin-fb",on:{"click":function($event){return _vm.loginFacebook($event)}}},[_c('i',{staticClass:"icon-fb"}),_vm._v(" Continue with Facebook ")])}
var staticRenderFns = []

export { render, staticRenderFns }